import { Box } from "arkh";
import React from "react";

export function WorkspaceRoutineTemplateItemRowContainer(props: {
  title: React.ReactNode;
  topic?: React.ReactNode;
  more: React.ReactNode;
}) {
  return (
    <Box style={{ flexDirection: "row", alignItems: "center" }}>
      <Box style={{ flex: 1, flexDirection: "row", alignItems: "center" }}>
        <Box style={{ width: "70%" }} spaceRight="medium">
          {props.title}
        </Box>

        {props.topic ? (
          <Box style={{ width: "20%", minWidth: 100 }} spaceRight="small">
            {props.topic}
          </Box>
        ) : null}
      </Box>

      <Box style={{ width: 20 }}>{props.more}</Box>
    </Box>
  );
}
